import fetch from 'isomorphic-fetch';
import { checkStatus } from '../util';
import { ROOT } from '../../constants/root';

export function createNewUser(userInfo, onSuccess, onError, ops) {
	return function(dispatch, getState) {

		const URL = `${ROOT}/user/manage_user/`;
		const json = userInfo;
		return fetch(URL, {
			method: ops,
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(json)
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => {
			/* eslint-disable no-new */
			let ans = ops === "POST" ? 'Usuário criado com sucesso!.' : 'Usuário editado com sucesso!';
			// new Event('ManageUser', 'createNewUser', ans);
			if (response.status !== 200) {
				throw new Error('Opss!');
			}
			onSuccess(ans); 
		})
		.catch((e) => {
			onError(e);
			console.error(e);
		});
	};
}

export function setNewUserGroups(groups) {
	return {
		type: "SET_NEW_USER_GROUPS",
		groups
	};	
}

export function setEdit(edit) {
	return {
		type: "SET_EDIT",
		edit
	};	
}
export function setID(id) {
	return {
		type: "SET_ID",
		id
	};
}
export function setMessage(message) {
	return {
		type: "SET_MESSAGE",
		message
	};	
}

export function setStatus(status) {
	return {
		type: "SET_STATUS",
		status
	};	
}

export function isFetching(bool) {
	return {
		type: "IS_FETCHING",
		bool
	};	
}

export function setNome(nome) {
	return {
		type: "SET_NOME",
		nome
	};
}

export function setSobrenome(sobrenome) {
	return {
		type: "SET_SOBRENOME",
		sobrenome
	};
}

export function setEmail(email) {
	return {
		type: "SET_EMAIL",
		email
	};
}

export function setUsername(username) {
	return {
		type: "SET_USERNAME",
		username
	};
}

export function setPassword(password) {
	return {
		type: "SET_PASSWORD",
		password
	};
}

export function setConfirmPassword(confirmpassword) {
	return {
		type: "SET_CONFIRMPASSWORD",
		confirmpassword
	};
}

export function setMariana(mariana) {
	return {
		type: "SET_MARIANA",
		mariana
	};
}

export function setBrumadinho(brumadinho) {
	return {
		type: "SET_BRUMADINHO",
		brumadinho
	};
}




// WEBPACK FOOTER //
// ./src/state/manageuser/actions.js